import { Pipe, PipeTransform, inject } from '@angular/core';
import { SucursalService } from '../services/sucursal.service';

/**
 * Pipe que transforma un ID de sucursal en su nombre
 *
 * Uso en template:
 * {{ sucursalId | nombreSucursal }}
 *
 * Ejemplo:
 * {{ 1 | nombreSucursal }} → "Sucursal Principal"
 */
@Pipe({
  name: 'nombreSucursal',
  standalone: true,
})
export class NombreSucursalPipe implements PipeTransform {
  private sucursalService = inject(SucursalService);

  transform(sucursalId: number | null | undefined): string {
    if (!sucursalId) return '';

    const sucursal = this.sucursalService.sucursalPorID(sucursalId);
    return sucursal?.nombre ?? '';
  }
}
